<script setup>
import { ref, onMounted, onUnmounted, watch, defineProps, computed } from "vue";
import {
  PencilSquareIcon,
  TrashIcon,
  CheckCircleIcon,
} from "@heroicons/vue/24/solid";
import { getUsers, getUserDetail, deleteUser } from "@/services/users";
/* import { getClients } from "@/services/clients"; */
import EditUserForm from "./EditUserForm.vue";
import { Toast } from "bootstrap";
import ModalDelete from "../ModalDelete.vue";

const showEditUserForm = ref(false);
const isDropdownOpen = ref(false);
const offcanvasEditUserFormRef = ref(null);
const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
});
console.log(props.data);

const selectedUser = ref(null);
const users = ref([]);
/* const showDeleteAlert = ref(false); */
const deletedUserName = ref("");
/* const clients = ref([]); */
const showSuccessMessage = ref(false);
const isUserEdited = ref(false);

const showDeleteModal = ref(false);
const userToDelete = ref(null);
const deleteToast = ref(null);

const usersPerPage = 10;
const currentPage = ref(1);
const paginatedUsers = computed(() => {
  const start = (currentPage.value - 1) * usersPerPage;
  return users.value.slice(start, start + usersPerPage);
});
const totalPages = computed(() => {
  return Math.ceil(users.value.length / usersPerPage) || 1;
});
const goToPage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};
const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

onMounted(async () => {
  const client_id = localStorage.getItem("cx");
  const response = await getUsers(client_id);
  console.log("Fetched USERS:", response);
  if (response.data.length) {
    users.value = response.data;
  }
  console.log("USERS:", users.value);
});

onMounted(() => {
  deleteToast.value.addEventListener("shown.bs.toast", () => {
    setTimeout(() => {
      deleteToast.value.classList.remove("show");
    }, 3000);
  });
});

const promptDeleteUser = (user) => {
  userToDelete.value = user;
  console.log("user to delete:", user);
  showDeleteModal.value = true;
};

const confirmDeleteUser = async () => {
  if (!userToDelete.value) return;
  try {
    const response = await deleteUser(userToDelete.value.id);
    console.log("Respuesta al eliminar usuario:", response);

    if (response.status === 200) {
      deletedUserName.value = userToDelete.value.name;
      users.value = users.value.filter((u) => u.id !== userToDelete.value.id);

      const bsToast = new Toast(deleteToast.value);
      bsToast.show();
    } else {
      console.error("La eliminación no fue exitosa:", response);
    }
  } catch (error) {
    console.error("Error al eliminar usuario:", error);
  } finally {
    showDeleteModal.value = false;
    userToDelete.value = null;
  }
};

const cancelDeleteUser = () => {
  showDeleteModal.value = false;
  userToDelete.value = null;
};

/* const deleteUserFunction = async (id, name) => {
  try {
    await deleteUser(id);
    users.value = users.value.filter((user) => user.id !== id);
    deletedUserName.value = name;
    showDeleteAlert.value = true;
    setTimeout(() => {
      showDeleteAlert.value = false;
    }, 3000);
  } catch (error) {
    console.error("Error al eliminar usuario:", error);
  }
}; */

async function toggleEditUserForm(user) {
  showEditUserForm.value = false;
  showSuccessMessage.value = false;
  try {
    const userDetails = await getUserDetail(user.id);
    const normalizedUser = {
      ...userDetails.data,
      id: userDetails.data.userId || userDetails.data.id, // Normaliza el ID
    };
    selectedUser.value = normalizedUser;
    console.log("Selected User with details:", selectedUser.value);
    showEditUserForm.value = true;
  } catch (error) {
    console.error("Error al obtener detalles del usuario:", error);
  }
}

/* Click fuera del dropdown */
onMounted(() => {
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".dropdown")) {
      isDropdownOpen.value = false;
    }
  });
});

const refreshUsers = async () => {
  const client_id = localStorage.getItem("cx");
  const response = await getUsers(client_id);
  if (response.data.length) {
    users.value = response.data;
  }
};

const handleKeySaved = (updatedUser) => {
  console.log("Datos recibidos en handleKeySaved:", updatedUser);
  if (typeof updatedUser === "object" && updatedUser !== null) {
    console.log("Usuario actualizado:", updatedUser);
    const index = users.value.findIndex((user) => user.id === updatedUser.id);
    if (index !== -1) {
      users.value[index] = updatedUser;
    } else if (updatedUser.id) {
      users.value.push(updatedUser);
    }
    isUserEdited.value = true;
    showEditUserForm.value = false;
    showSuccessMessage.value = true;
    refreshUsers();
  } else {
    console.warn("Formato de datos inesperado:", updatedUser);
  }
};

const closeOffcanvas = () => {
  showEditUserForm.value = false;
  if (!isUserEdited.value) {
    showSuccessMessage.value = false;
  }
};

const handleEscape = (event) => {
  if (event.key === "Escape") {
    closeOffcanvas();
  }
};
onMounted(() => {
  window.addEventListener("keydown", handleEscape);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEscape);
});

watch(showEditUserForm, (newValue) => {
  if (!newValue) {
    setTimeout(() => {
      const offcanvasElement = document.querySelector("#offcanvasEditUserForm");
      offcanvasElement.classList.add("show"); // Mostrar el offcanvas
    }, 100);
  }
});
</script>
<template>
  <div class="rounded-lg table-container" style="width: 100%">
    <table class="table" style="width: 100%">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Correo electrónico</th>
          <th style="text-align: center">Cliente</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in paginatedUsers" :key="user.id">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td style="text-align: center">
            {{ user.client }}
          </td>
          <td
            class="d-flex gap-3 actions-column mx-2 justify-content-around"
            style="margin-top: 3px; border-bottom: none"
          >
            <button
              class="buttons-group"
              @click="toggleEditUserForm(user)"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasEditUserForm"
              aria-controls="offcanvasEditUserForm"
            >
              <PencilSquareIcon
                class="text-blue-500 d-flex justify-content-center"
                style="color: #517fa4; width: 23px; height: 23px"
              ></PencilSquareIcon>
            </button>
            <button
              class="buttons-group delete"
              @click="promptDeleteUser(user)"
            >
              <TrashIcon
                class="text-blue-500 d-flex justify-content-center"
                style="width: 23px; height: 23px"
              ></TrashIcon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- PAGINACIÓN -->
    <div class="pagination-container d-flex flex-column align-items-end mt-3">
      <div class="pagination-controls d-flex align-items-center gap-2 justify-content-end">
        <button class="pagination-btn" :disabled="currentPage === 1" @click="prevPage">&lt;</button>
        <button
          v-for="page in totalPages"
          :key="page"
          class="pagination-btn"
          :class="{ active: page === currentPage }"
          @click="goToPage(page)"
        >
          {{ page }}
        </button>
        <button class="pagination-btn" :disabled="currentPage === totalPages" @click="nextPage">&gt;</button>
      </div>
      <div class="pagination-info mt-2 text-end">
        Mostrando
        <b>{{ (currentPage - 1) * usersPerPage + 1 }}</b>
        -
        <b>{{ Math.min(currentPage * usersPerPage, users.length) }}</b>
        de
        <b>{{ users.length }}</b>
        resultados
      </div>
    </div>
    <!-- FIN PAGINACIÓN -->
    <!-- <div
      v-if="showDeleteAlert"
      class="alert alert-dark alert-dismissible fade show"
      role="alert"
    >
      ¡El usuario {{ deletedUserName }} ha sido eliminado exitosamente!
      <button
        type="button"
        class="btn-close"
        @click="showDeleteAlert = false"
        aria-label="Close"
      ></button>
    </div> -->
    <div
      class="toast align-items-center position-fixed top-50 end-0 p-2 w-auto"
      style="background: #243949; color: white; width: auto"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      id="deleteToast"
      ref="deleteToast"
    >
      <div class="d-flex">
        <div class="toast-body">
          Se ha eliminado el usuario
          <span
            style="
              font-weight: 600;
              text-decoration: underline;
              text-transform: capitalize;
            "
          >
            {{ deletedUserName }}
          </span>
          con éxito.
        </div>
        <button
          type="button"
          class="btn-close me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
    </div>
    <!-- Alerta de eliminación -->
  </div>
  <div
    class="offcanvas offcanvas-end"
    style="width: 45%"
    data-bs-scroll="true"
    tabindex="-1"
    id="offcanvasEditUserForm"
    aria-labelledby="offcanvasEditUserFormLabel"
    ref="offcanvasEditUserFormRef"
  >
    <div class="offcanvas-header">
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body" v-if="showEditUserForm">
      <EditUserForm
        :offcanvasRef="offcanvasEditUserFormRef"
        :newKeyData="selectedUser"
        @keySaved="handleKeySaved"
        @cancelEdit="closeOffcanvas"
      ></EditUserForm>
    </div>
    <!-- *Mensaje -->
    <div
      v-if="showSuccessMessage"
      class="offcanvas-body"
      style="text-align: center; margin-top: 8rem"
    >
      <CheckCircleIcon
        style="width: 5rem; height: 5rem; color: #517fa4"
      ></CheckCircleIcon>
      <h4 class="create-title mt-3">El Usuario se editó con éxito.</h4>
      <button
        class="globals-border-button"
        data-bs-dismiss="offcanvas"
        style="margin-top: 3rem"
      >
        Salir
      </button>
    </div>
  </div>

  <ModalDelete
    :show="showDeleteModal"
    title="Confirmar Eliminación"
    :message="`¿Estás seguro de que deseas eliminar el usuario <strong>${userToDelete?.name}</strong>?`"
    @confirm="confirmDeleteUser"
    @cancel="cancelDeleteUser"
  />
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.actions-column {
  position: sticky;
  right: 0;
  margin-left: 4px;
  margin-right: 4px;
}
.buttons-group {
  border: none;
  background: transparent;
  cursor: pointer;
}
.delete:hover {
  background-color: $gradient-color-01;
}
.rounded-lg {
  border-radius: 10px;
  overflow: hidden;
}
.table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 6px 8px 6px 8px;
  margin-top: 3px;
  margin: 4px;
  text-align: start;
  border-bottom: 1px solid $seven-color;
  white-space: nowrap;
}

th {
  background-color: $seven-color;
  color: $primary-color;
  text-align: start;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 5px 2px 5px 2px;
}

.under-th {
  height: 10px;
  font-size: x-small;
  padding: 2px;
}

.table-container {
  width: 100%;
  max-width: none;
  overflow-x: auto;
  overflow-y: hidden;
}

.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  background-color: $white-color;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: $seven-color;
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background-color: $six-color;
}

.pagination-container {
  width: 100%;
  margin-top: 1.5rem;
  align-items: flex-end;
}
.pagination-controls {
  gap: 0.5rem;
}
.pagination-btn {
  border: 1.5px solid #355E77;
  background: #fff;
  color: #355E77;
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s, color 0.18s, border 0.18s;
  cursor: pointer;
  margin: 0 2px;
}
.pagination-btn.active, .pagination-btn:hover {
  background: #355E77;
  color: #fff;
  border: 1.5px solid #355E77;
}
.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-info {
  font-size: 0.98rem;
  color: #355E77;
  margin-top: 0.5rem;
}
</style>
